import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function FailedAttempts() {
  const attempts = [{
    title: 'Cursos de Diseño Tradicional',
    desc: 'Toman meses en dominarse y requieren software caro como Photoshop.'
  }, {
    title: 'Dropshipping',
    desc: 'Tiene márgenes mínimos y te obliga a lidiar con proveedores y devoluciones.'
  }, {
    title: 'IA sin Estrategia',
    desc: 'Intentar usar la IA sin guía resulta en imágenes genéricas que nadie quiere comprar.'
  }, {
    title: 'Marketing de Afiliados',
    desc: "Te obliga a ser 'influencer' y mostrar tu cara ante miles de personas."
  }];
  return <section className="py-16 md:py-24 bg-white px-4 sm:px-6 lg:px-8" data-id="element-32">
      <div className="max-w-5xl mx-auto" data-id="element-33">
        <FadeIn data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-darkText mb-16" data-id="element-35">
            Por qué lo que has intentado no funcionó
          </h2>
        </FadeIn>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-36">
          {attempts.map((item, idx) => <FadeIn key={idx} delay={idx * 0.1} direction="up" data-id="element-37">
              <div className="flex gap-4 p-6 rounded-2xl bg-cream/50 border border-cream hover:bg-cream transition-colors" data-id="element-38">
                <div className="flex-shrink-0 mt-1" data-id="element-39">
                  <XCircle className="w-6 h-6 text-peach" data-id="element-40" />
                </div>
                <div data-id="element-41">
                  <h3 className="text-lg font-bold text-darkText mb-2" data-id="element-42">
                    {item.title}
                  </h3>
                  <p className="text-lightText" data-id="element-43">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}